import { AccountRelationshipType } from '@ibk/shared-types';
import { maskCnpj, maskCpf } from '../formatters';
import { isValidCnpj, isValidCpf } from '../validators';
export function getAccountName(account) {
    if (!account) {
        return '';
    }
    const companyName = 'companyName' in account ? account.companyName : account.entity?.companyName;
    const firstName = 'firstName' in account ? account.firstName : account.entity?.firstName;
    const lastName = 'lastName' in account ? account.lastName : account.entity?.lastName;
    if (companyName) {
        return companyName;
    }
    if (firstName && lastName) {
        return firstName + ' ' + lastName;
    }
    return firstName ?? lastName;
}
export function getAccountIdentifierFormatted(identifier) {
    if (!identifier) {
        return '';
    }
    if (isValidCnpj(identifier)) {
        return maskCnpj(identifier);
    }
    if (isValidCpf(identifier)) {
        return maskCpf(identifier);
    }
    return '';
}
export function isOwnerOrHolder(selectedAccount) {
    return (selectedAccount?.accountRelationshipType === AccountRelationshipType.OWNER ||
        selectedAccount?.accountRelationshipType === AccountRelationshipType.HOLDER);
}
